/* template */
<template minapp="mpx" xlang="wxml"><div class="es-content__box" v-if="(isCardListShow)"><div v-for="(item, index) in (innerValue)" class="es-content__vbox"><div class="es-content__card"><es-card :layout="(index === 0?['header']:[])" custom-header="es-content__miniapp_card_header" custom-body="es-content__miniapp_card_body"><div slot="header" v-if="(index === 0)">证件信息</div><es-credentials :isAddPage="(isAddPage)" :cardType="(item)" :secretKey="(secret_key)" :isCanDelete="(!isOneCardShow)" :isIdNoDisable="(isIdNoDisable)" :isIdTypeDisable="(isIdTypeDisable)" :cardTypeList="(isOneCardShow ? originCardTypeList : cardTypeList)" :isRequiredShow="(isOneCardShow ?  false : isRequiredShow)" :expireDateConfig="(expireDateConfig)" :aesOriginCardList="(aesOriginCardList)" @change-item="changeCardType" @delete-item="deleteCardType" @input-change="inputCardNo" @expired-date-change="changeExpiredDate"/></es-card></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m4c87468a"}'>
  +b('content')
    +e('add')
      margin 0 12px 12px
    +e('name-box')
      display flex
      width 80px
    +e('required-text')
      color #F93822
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 76px
        right 0
    +e('foreigner')
      font-size 12px
      line-height 1
      color #999999
      transform scale(0.83)
      margin-left -4px
    +e('box')
      margin 12px
    +e('card')
      background-color #ffffff
      border-radius 8px
      color #333333
      /deep/ .placeholder
        color #999999
      // h5用
      /deep/ .es-card__header
        line-height 38px
        font-size 16px
        font-weight bold
        margin 4px 12px
        padding 0
        border-bottom 0.5px solid rgba(235, 237, 240, 0.6)
      // h5用
      /deep/ .es-cell
        height 54px
        color #333333
        padding 10px 0
        &::after
          border-bottom 1px solid #f0f2f7
          left 76px
          right 0
      // h5用
      /deep/ .es-cell:last-child
        &::after
          // border-bottom none
      // h5用
      /deep/ .es-cell-custom
        height 44px
        &::after
          border-bottom 1px solid #eeeeee
          left 0
          right 0
      // h5用
      /deep/ .es-cell-custom:last-child
        &::after
          border-bottom 1px solid #eeeeee
      // h5用
      /deep/ .es-field__body
        color currentColor
    // 小程序用
    +e('miniapp_card_header')
      line-height 38px
      font-size 16px
      font-weight bold
      margin 4px 12px
      padding 0
    // 小程序用
    +e('miniapp_card_body')
      padding 0 12px !important
    // 小程序用
    +e('vbox')
      margin 12px 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m4c87468a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./card-list.mpx.js?isComponent&outputPath=components%2Fcard-list4c87468a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./card-list.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcard-list4c87468a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m4c87468a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/card-list4c87468a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-card':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/card/index.mpx?isComponent&outputPath=components%2Findex340a2e8c%2Findex")),'add-button':getComponent(require("../../add-button/index.mpx?isComponent&outputPath=components%2Findex6e00a244%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex")),'es-credentials':getComponent(require("../../credentials/index.mpx?isComponent&outputPath=components%2Findex2341b72a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
